export default __webpack_public_path__ + "static/media/logo.02f11b61.svg";